import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';

const SectionMappedAcademicYear = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        sectionMasterId: sectionMasterId,
        academicYearMasterId: '',
        startDate: '',
        endDate: '',
    }

    const [yearList, setYearList] = useState([]);
    const [mappedData, setMappedData] = useState(initialFormState);
    const [mappedList, setMappedList] = useState([]);
    const [editId, setEditId] = useState(null);

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getYearList()
    }, []);

    useEffect(() => {
        getMappedData();
    }, [mappedData]);

    const getMappedData = () => {
        if (mappedData.academicYearMasterId !== '') {
            let apiUrl = '/get-sections-academic-years?';
            if (mappedData.sectionMasterId !== '') {
                apiUrl += `sectionMasterId=${mappedData.sectionMasterId}&`;
            }
            if (mappedData.academicYearMasterId !== '') {
                apiUrl += `academicYearMasterId=${mappedData.academicYearMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
                .then(response => {
                    setMappedList(response.data.data);
                })
                .catch(error => {
                    setMappedList(error?.response?.data.result);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    const getYearList = () => {
        const apiUrlForSyllabus = `/active-academic-years`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setMappedData((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })
    }

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(mappedData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(mappedData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [mappedData])

    const mappedSectionWithAcademicYear = () => {
        const apiUrl = `/add-sections-academic-years`;
        if (validateForm()) {
            setLoading(true);
            authorizedAxiosSection && authorizedAxiosSection.post(apiUrl, mappedData)
                .then(response => {
                    setMappedData((prevData) => {
                        return {
                            ...prevData,
                            startDate: "",
                            endDate: ""
                        }
                    })
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(mappedData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const updateMappedData = async () => {
        if (validateForm()) {
            setLoading(true);
            const apiUrl = `/edit-sections-academic-years?id=${editId}`;
            try {
                const response = await authorizedAxiosSection.put(apiUrl, mappedData);
                getMappedData();
                setEditId(null);
                setMappedData(prevData => ({
                    ...prevData,
                    startDate: "",
                    endDate: ""
                }));
                Swal.fire({ text: response.data.message });
            } catch (error) {
                if (!error?.response?.data?.data) {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({ text: errorMsg });
                } else {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({
                        title: errorMsg,
                        text: 'Do you want to forcefully update the Academic year?',
                        icon: 'error',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        showLoaderOnConfirm: true,
                        preConfirm: async () => {
                            return Swal.fire({
                                html: `
                                    <div>
                                        <p>Enter Administrative Password:</p>
                                        <input type="password" id="swal-input" class="swal2-input" placeholder="Password">
                                    </div>
                                `,
                                showCancelButton: true,
                                confirmButtonText: 'Submit',
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    const inputValue = document.getElementById('swal-input').value;
                                    const forceApiUrl = `/force-edit-sections-academic-years?id=${editId}`;
                                    try {
                                        const forceResponse = await authorizedAxiosSection.put(forceApiUrl, {
                                            ...mappedData,
                                            password: inputValue
                                        });
                                        getMappedData();
                                        setEditId(null);
                                        setMappedData(prevData => ({
                                            ...prevData,
                                            startDate: "",
                                            endDate: ""
                                        }));
                                        Swal.fire({ text: forceResponse.data.message });
                                    } catch (forceError) {
                                        const forceErrorMsg = forceError?.response?.data?.message || 'Force update failed!';
                                        Swal.fire({ text: forceErrorMsg });
                                    }
                                }
                            });
                        }
                    });
                }
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(mappedData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteMappedData = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-sections-academic-years?id=${id}`;
            authorizedAxiosSection && authorizedAxiosSection.delete(apiUrl)
                .then(response => {
                    getMappedData();

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const changeActive = async (id, isActive) => {
        const action = isActive ? 'activate' : 'deactivate';

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to ${action} this Academic year?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
        });

        if (!result.isConfirmed) return;

        setLoading(true);
        const apiUrl = `/active-inactive-sections-academic-years?sectionMasterId=${sectionMasterId}&id=${id}&isActive=${isActive}`;
        try {
            const response = await authorizedAxiosSection.patch(apiUrl);
            getMappedData();
            Swal.fire({ text: response.data.message });
        } catch (error) {
            // const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            // Swal.fire({ text: errorMsg });

            if(!error?.response?.data?.data) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            } else {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({
                    title: errorMsg,
                    text: 'Do you want to change the status forcefully?',
                    icon: 'error',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showLoaderOnConfirm: true,
                    preConfirm: async () => {
                        return Swal.fire({
                            html: `
                                <div>
                                    <p>Enter Administrative Password:</p>
                                    <input type="password" id="swal-input" class="swal2-input" placeholder="Password">
                                </div>
                            `,
                            showCancelButton: true,
                            confirmButtonText: 'Submit',
                        }).then(async (result) => {
                            if (result.isConfirmed) {
                                const inputValue = document.getElementById('swal-input').value;
                                const forceApiUrl = `/force-active-inactive-sections-academic-years?sectionMasterId=${sectionMasterId}&id=${id}&isActive=${isActive}`;
                                try {
                                    const forceResponse = await authorizedAxiosSection.patch(forceApiUrl, { password: inputValue });
                                    getMappedData();
                                    Swal.fire({ text: forceResponse.data.message });
                                } catch (forceError) {
                                    const forceErrorMsg = forceError?.response?.data?.message || 'Force update failed!';
                                    Swal.fire({ text: forceErrorMsg });
                                }
                            }
                        });
                    }
                });
            }
        } finally {
            setLoading(false);
        }
    }

    const handleReset = () => {
        setMappedData(initialFormState);
        setMappedList([]);
        setEditId(null);
        setError(initialErrorState);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Mapped Academic Year</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>Mapped Academic Year</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Academic Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleInputChange} value={mappedData.academicYearMasterId}>
                                                        <option selected value={''} disabled>Select Academic Year</option>
                                                        {
                                                            yearList?.map((academicYear) => {
                                                                return <option value={academicYear.id}>{academicYear.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="startDate" className="col-form-label"><span style={{ color: "red" }}>*</span>Start Date</label>
                                                    <input type="date" placeholder="month-academicYearMasterId" className="form-control" id="startDate" name='startDate' onChange={handleInputChange} value={mappedData.startDate} />
                                                    {error.startDate && <p style={{ color: 'red' }}>{error.startDate}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="endDate" className="col-form-label"><span style={{ color: "red" }}>*</span>End Date</label>
                                                    <input type="date" className="form-control" id="endDate" name='endDate' onChange={handleInputChange} value={mappedData.endDate} />
                                                    {error.endDate && <p style={{ color: 'red' }}>{error.endDate}</p>}
                                                </div>
                                            </div>

                                            <div className="row">

                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={mappedSectionWithAcademicYear}>Mapped</button>}
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleReset}>Reset</button>
                                                        {editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateMappedData} disabled={!editId}>Update</button>)}
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Academic Year</th>
                                                                        <th scope="col">Start Date</th>
                                                                        <th scope="col">End Date</th>
                                                                        <th scope='col' className='text-center toggle_switch_id'>Active/Inactive</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        mappedList?.length > 0 ?
                                                                            mappedList?.map((data, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                        <td>{data.academicYearMasterDetails.yearName}</td>
                                                                                        <td>{data.startDate}</td>
                                                                                        <td>{data.endDate}</td>
                                                                                        <td className='toggle_switch_id'>
                                                                                            <div className={`toggle-container margin-inline ${data.isActive ? 'active' : ''}`} onClick={() => changeActive(data.id, !data.isActive)} >
                                                                                                <div className="toggle-background"></div>
                                                                                                <div className="toggle-switch"></div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setMappedData({
                                                                                                    sectionMasterId: sectionMasterId,
                                                                                                    academicYearMasterId: data.academicYearMasterDetails.id,
                                                                                                    startDate: data.startDate,
                                                                                                    endDate: data.endDate
                                                                                                })
                                                                                                setEditId(data.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === data.id} onClick={() => deleteMappedData(data.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Mapped Academic Year Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionMappedAcademicYear
